/**
*   Custom JavaScript
*/

window.addEventListener('DOMContentLoaded', () => {

    /**
    *   Lazyload Blog Detail Images
    */
    if (document.body.classList.contains('article')) {
        let articleContent = document.querySelector('.article-template__content');
        let images         = articleContent ? articleContent.querySelectorAll('img') : null;

        if (images) {
            images.forEach(img => {
                img.setAttribute('loading', 'lazy');

                img.onload = () => {
                    img.setAttribute('width', img.width);
                    img.setAttribute('height', img.height);
                }
            });
        }
    }
});